export const useStyles = (theme) => ({
  coverImageStyle: {
    width: 200,
    height: 260,
    [theme.breakpoints.down("sm")]: {
      width: 250,
      height: 350,
    },
  },
  contentStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  cancelButtonStyle: {
    "&:hover": {
      backkgroundColor: "transparent",
    },
  },
  payButtonStyle: {
    outline: "none",
    variant: "contained",
    color: "#ffffff",
    backgroundColor: "blue !important",
    outlineColor: "blue !important",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
});
